import ne from "./ghl-ui.es1516.js";
import Z from "./ghl-ui.es1520.js";
import ae from "./ghl-ui.es723.js";
import oe from "./ghl-ui.es1508.js";
import B from "./ghl-ui.es1506.js";
import ie from "./ghl-ui.es1521.js";
import G from "./ghl-ui.es1510.js";
import le from "./ghl-ui.es1511.js";
import { isProtectedWeekYearToken as fe, throwProtectedError as J, isProtectedDayOfYearToken as se } from "./ghl-ui.es1512.js";
import V from "./ghl-ui.es1505.js";
import ue from "./ghl-ui.es1466.js";
import { DateToSystemTimezoneSetter as ve } from "./ghl-ui.es1522.js";
import { parsers as ce } from "./ghl-ui.es1523.js";
import { getDefaultOptions as de } from "./ghl-ui.es1513.js";
var me = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ge = /^'([^]*?)'?$/, he = /''/g, ke = /\S/, we = /[a-zA-Z]/;
function Pe(o, X, q, r) {
  var m, p, g, h, k, w, _, O, y, D, S, $, E, N, T, C, W, b;
  ue(3, arguments);
  var a = String(o), f = String(X), i = de(), s = (m = (p = r == null ? void 0 : r.locale) !== null && p !== void 0 ? p : i.locale) !== null && m !== void 0 ? m : ae;
  if (!s.match)
    throw new RangeError("locale must contain match property");
  var x = V((g = (h = (k = (w = r == null ? void 0 : r.firstWeekContainsDate) !== null && w !== void 0 ? w : r == null || (_ = r.locale) === null || _ === void 0 || (O = _.options) === null || O === void 0 ? void 0 : O.firstWeekContainsDate) !== null && k !== void 0 ? k : i.firstWeekContainsDate) !== null && h !== void 0 ? h : (y = i.locale) === null || y === void 0 || (D = y.options) === null || D === void 0 ? void 0 : D.firstWeekContainsDate) !== null && g !== void 0 ? g : 1);
  if (!(x >= 1 && x <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R = V((S = ($ = (E = (N = r == null ? void 0 : r.weekStartsOn) !== null && N !== void 0 ? N : r == null || (T = r.locale) === null || T === void 0 || (C = T.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && E !== void 0 ? E : i.weekStartsOn) !== null && $ !== void 0 ? $ : (W = i.locale) === null || W === void 0 || (b = W.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && S !== void 0 ? S : 0);
  if (!(R >= 0 && R <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (f === "")
    return a === "" ? B(q) : /* @__PURE__ */ new Date(NaN);
  var A = {
    firstWeekContainsDate: x,
    weekStartsOn: R,
    locale: s
  }, P = [new ve()], ee = f.match(pe).map(function(t) {
    var e = t[0];
    if (e in G) {
      var n = G[e];
      return n(t, s.formatLong);
    }
    return t;
  }).join("").match(me), F = [], u = Z(ee), z;
  try {
    var re = function() {
      var e = z.value;
      !(r != null && r.useAdditionalWeekYearTokens) && fe(e) && J(e, f, o), !(r != null && r.useAdditionalDayOfYearTokens) && se(e) && J(e, f, o);
      var n = e[0], d = ce[n];
      if (d) {
        var Q = d.incompatibleTokens;
        if (Array.isArray(Q)) {
          var K = F.find(function(U) {
            return Q.includes(U.token) || U.token === n;
          });
          if (K)
            throw new RangeError("The format string mustn't contain `".concat(K.fullToken, "` and `").concat(e, "` at the same time"));
        } else if (d.incompatibleTokens === "*" && F.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(e, "` and any other token at the same time"));
        F.push({
          token: n,
          fullToken: e
        });
        var I = d.run(a, e, s.match, A);
        if (!I)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        P.push(I.setter), a = I.rest;
      } else {
        if (n.match(we))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + n + "`");
        if (e === "''" ? e = "'" : n === "'" && (e = _e(e)), a.indexOf(e) === 0)
          a = a.slice(e.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (u.s(); !(z = u.n()).done; ) {
      var L = re();
      if (ne(L) === "object")
        return L.v;
    }
  } catch (t) {
    u.e(t);
  } finally {
    u.f();
  }
  if (a.length > 0 && ke.test(a))
    return /* @__PURE__ */ new Date(NaN);
  var te = P.map(function(t) {
    return t.priority;
  }).sort(function(t, e) {
    return e - t;
  }).filter(function(t, e, n) {
    return n.indexOf(t) === e;
  }).map(function(t) {
    return P.filter(function(e) {
      return e.priority === t;
    }).sort(function(e, n) {
      return n.subPriority - e.subPriority;
    });
  }).map(function(t) {
    return t[0];
  }), Y = B(q);
  if (isNaN(Y.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var l = oe(Y, le(Y)), M = {}, v = Z(te), j;
  try {
    for (v.s(); !(j = v.n()).done; ) {
      var H = j.value;
      if (!H.validate(l, A))
        return /* @__PURE__ */ new Date(NaN);
      var c = H.set(l, M, A);
      Array.isArray(c) ? (l = c[0], ie(M, c[1])) : l = c;
    }
  } catch (t) {
    v.e(t);
  } finally {
    v.f();
  }
  return l;
}
function _e(o) {
  return o.match(ge)[1].replace(he, "'");
}
export {
  Pe as default
};
